import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { PhonebookPage } from './pages/phonebook/phonebook.page';
import { HomePage } from './pages/home/home.page';
import { SlsstatusPage } from './pages/accelerators/slsstatus/slsstatus.page';
import { HipastatusPage } from './pages/accelerators/hipastatus/hipastatus.page';
import { ProscanstatusPage } from './pages/accelerators/proscanstatus/proscanstatus.page';
import { SwissfelstatusPage } from './pages/accelerators/swissfelstatus/swissfelstatus.page';
import { PublicTransportPage } from './pages/public-transport/public-transport.page';
import { MapPage } from './pages/map/map.page';
import { InfoPage } from './pages/infopage/infopage.page';
import { HighlightsPage } from './pages/highlights/highlights.page';
import { ZptContactsPage } from './pages/zpt/zpt-contacts/zpt-contacts.page';
import { OasemenuPage } from './pages/oasemenu/oasemenu.page';
import { FoodmarketPage } from './pages/foodmarket/foodmarket.page';
import { PiaCulinaarePage } from './pages/pia-culinaare/pia-culinaare.page';
import { RecyclingPage } from './pages/recycling/recycling.page';


const routes: Routes = [
  {
    path: '',
    redirectTo: 'home',
    pathMatch: 'full'
  },
  {
    path: 'home',
    component: HomePage
  },


  //! GFA (ACCELERATORS)
  {
    path: 'slsstatus',
    component: SlsstatusPage
  },
  {
    path: 'hipastatus',
    component: HipastatusPage
  },
  {
    path: 'proscanstatus',
    component: ProscanstatusPage
  },
  {
    path: 'swissfelstatus',
    component: SwissfelstatusPage
  },

  //* SBB Buses
  {
    path: 'publictransport',
    component: PublicTransportPage
  },

  //* PSI Map, with Searching.
  {
    path: 'psimap',
    component: MapPage
  },

  //* Phonebook 
  {
    path: 'phonebook',
    component: PhonebookPage
  },

  //* FAQ  
  {
    path: 'infopage',
    component: InfoPage
  },

  //* CPT Highlights
  {
    path: 'scientific-highlights',
    component: HighlightsPage
  },

  //* CPT Contacts
  {
    path: 'cpt-contacts',
    component: ZptContactsPage
  },

  //* Oase Menu
  {
    path: 'oasemenu',
    component: OasemenuPage
  },

  //* Foodmarket (Timeout) Westen
  {
    path: 'foodmarket',
    component: FoodmarketPage
  },

  //* PIA Culinaare
  {
    path: 'pia-culinaare',
    component: PiaCulinaarePage
  },

  //* Recycling Map
  {
    path: 'recycling',
    component: RecyclingPage
  },



];

@NgModule({
  imports: [RouterModule.forRoot(routes, {})],
  exports: [RouterModule]
})
export class AppRoutingModule { }
